import { Sprout, ShieldCheck, PackageOpen, Ship, MapPin } from "lucide-react";

const steps = [
  { icon: Sprout, name: "Sourcing", desc: "Direct from vetted farm cooperatives and origin markets." },
  { icon: ShieldCheck, name: "Quality Control", desc: "Lab-tested for moisture, purity, aflatoxin and pesticide residue." },
  { icon: PackageOpen, name: "Packaging", desc: "Buyer-spec jute, PP, vacuum, or custom retail packs." },
  { icon: Ship, name: "Logistics", desc: "FCL / LCL, reefer, and air freight with full documentation." },
  { icon: MapPin, name: "Delivery", desc: "CIF, FOB, DAP — arriving on schedule at your port." },
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="py-24 md:py-32 bg-[#F9F8F6]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-16 reveal">
          <p className="overline">How we work</p>
          <h2 className="mt-4 font-serif-display text-4xl md:text-5xl lg:text-6xl text-[#1A3626] leading-tight tracking-tight">
            From origin to port,<br />handled with care.
          </h2>
        </div>

        <div className="relative">
          <div className="hidden md:block absolute left-0 right-0 top-8 h-px bg-[#1A3626]/15"></div>
          <div className="grid grid-cols-1 md:grid-cols-5 gap-10 md:gap-4">
            {steps.map((s, i) => (
              <div key={s.name} className="relative reveal">
                <div className="relative flex md:block items-start gap-4">
                  <div className="h-16 w-16 md:h-16 md:w-16 bg-white border border-[#1A3626]/15 flex items-center justify-center relative z-10">
                    <s.icon className="text-[#1A3626]" size={26} strokeWidth={1.25} />
                  </div>
                  <div className="md:mt-6">
                    <div className="overline text-[#C5A059] mb-2">Step 0{i + 1}</div>
                    <h3 className="font-serif-display text-2xl text-[#1A3626] leading-tight">
                      {s.name}
                    </h3>
                    <p className="mt-2 text-sm text-[#4B5563] leading-relaxed">
                      {s.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
